import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import { AxiosInstance, AxiosPromise } from 'axios';
import {
  PermissionResetRequest,
  PermissionSearchRequest,
  PermissionSearchResponse,
  PermissionUpdateRequest,
} from './PermissionsService.types';

export class PermissionsService implements BaseRequestEndpoints {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search({ routeParams, queryParams }: PermissionSearchRequest) {
    return this.instance.get<PermissionSearchResponse>(`/roles/${routeParams.roleId}/permissions`, {
      params: queryParams,
    });
  }

  reset({ routeParams }: PermissionResetRequest) {
    return this.instance.put<PermissionSearchResponse>(`/roles/${routeParams.roleId}/reset`);
  }

  create(request: BaseRequestEndpoints): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  getById(request: BaseRequestEndpoints): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  update({ routeParams, body }: PermissionUpdateRequest) {
    return this.instance.put<PermissionSearchResponse>(
      `/roles/${routeParams.roleId}/permissions`,
      body,
    );
  }

  delete(request: BaseRequestEndpoints): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }
}
